var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppContent',{attrs:{"resourcePath":_vm.resourcePath,"headers":_vm.headers,"title":_vm.title,"subject":_vm.subject,"table-props":{
    downloadable: false,
    itemKey: 'id',
    headers: _vm.headers,
    itemActions: ['edit', 'delete'],
  }},scopedSlots:_vm._u([{key:"form",fn:function(slotProps){return [_c('OpportunityForm',_vm._b({ref:"form"},'OpportunityForm',slotProps,false))]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }